import { FC, useCallback, useContext } from 'react';

import { AsyncMultiselect } from 'components';
import { TruckingCompany } from 'types';

import { useFetch } from 'hooks';
import { formatTruckingCompany } from 'utils/format';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryAddTruckingCompany: FC = () => {
  const { truckingCompanies, setTruckingCompanies } = useContext(RedeliveryContext);
  const { fetchPaginated } = useFetch<TruckingCompany>('trucking-companies/page');

  const handleSelect = useCallback(
    (option: TruckingCompany) => {
      setTruckingCompanies(prevState => {
        const stateCopy = new Map(prevState);
        if (stateCopy.has(option.id)) stateCopy.delete(option.id);
        else stateCopy.set(option.id, option);
        return stateCopy;
      });
    },
    [setTruckingCompanies]
  );

  return (
    <AsyncMultiselect<TruckingCompany>
      id="redelivery-trucking-company-search"
      data-cy="redelivery-trucking-company-search"
      fetchData={fetchPaginated}
      formatOption={formatTruckingCompany}
      customSelect={handleSelect}
      label="CARRIER"
      rowSelection={truckingCompanies}
      sortField="name"
      style={{ flexBasis: 256, flexShrink: 0 }}
    />
  );
};

export default RedeliveryAddTruckingCompany;
